import { getAllAnswers } from '@/utils/onboardingStorage'
import { toneVariant, useCompanionNoun } from '@/utils/personalization'
import ContinueButton from '@app-studio-web/ui/components/ContinueButton'
import PageLayout from '@app-studio-web/ui/components/PageLayout'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Form } from 'react-router-dom'

const SUMMARY_KEYS: Record<string, string> = {
  challenge: 'challenge',
  'comm-style': 'commStyle',
  frequency: 'frequency',
  goal: 'goal',
  personality: 'personality',
  topics: 'topics',
}

export default function SummaryPage() {
  const { t } = useTranslation()
  const noun = useCompanionNoun()
  const tags = useMemo(() => {
    const answers = getAllAnswers()
    return Object.entries(SUMMARY_KEYS).flatMap(([storageKey, i18nSection]) => {
      const entry = answers[storageKey]
      if (!entry) return []
      const raw = entry.answer || entry.answer_key
      if (!raw) return []
      const values =
        storageKey === 'topics'
          ? raw
              .split(',')
              .map((v) => v.trim())
              .filter(Boolean)
          : [raw]
      return values.map((value) =>
        t(`pages.onboarding.${i18nSection}.${value}`, {
          defaultValue: value,
        }),
      )
    })
  }, [t])

  return (
    <PageLayout>
      <div className="flex grow flex-col items-center justify-center text-center">
        <div
          className="mb-6 flex h-20 w-20 items-center justify-center rounded-full text-4xl shadow-[0_8px_30px_rgba(45,45,45,0.18)]"
          style={{
            background: '#2D2D2D',
            animation: 'heartFloat 3.5s ease-in-out infinite',
          }}
        >
          🤍
        </div>
        <h2 className="text-primary mb-2 font-serif text-3xl font-normal">
          {t('pages.onboarding.summary.title')}
        </h2>
        <p className="text-muted mb-6">
          {t(toneVariant('pages.onboarding.summary.subtitle'), { noun })}
        </p>
        <div className="flex max-w-[420px] flex-wrap justify-center gap-2">
          {tags.map((tag, index) => (
            <span
              key={`${tag}-${index}`}
              className="bg-surface text-primary rounded-full px-4 py-2 text-sm font-semibold"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
      <Form className="sticky bottom-14 z-20 shrink-0" method="post">
        <ContinueButton />
      </Form>
    </PageLayout>
  )
}
